var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v2-table',{attrs:{"url":"/api/v1/emailLog?paginate","headers":[
    {
      text: 'Id'
    },
    {
      text: 'User'
    },
    {
      text: 'Betreff'
    },
    {
      text: 'Typ'
    },
    {
      text: 'Datum'
    },
    {
      text: 'Nachricht'
    }
  ]},scopedSlots:_vm._u([{key:"row",fn:function(ref){
  var item = ref.item;
return _c('tr',{},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('e-mail-log-to-cell',{attrs:{"model":item,"content":item.to}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subject))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('date-time-cell',{attrs:{"content":item.created_at}}),_vm._v(" "),_c('modal-cell',{attrs:{"attribute":{ mode: 'emailLog', modal: 'EMailLogModal' },"model":item}})],1)}}])},[_c('template',{slot:"filter"},[_c('date-range-filter',{attrs:{"titel":"Zeitraum","name":"created_at_between"}}),_vm._v(" "),_c('basic-filter',{attrs:{"titel":"E-Mail-Adresse","name":"to"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }